export default{
  top1: '概览',
  top2: '技术规格',
  dec: '10分钟复刻空间（100m²），时间仅需传统设备的1/20，4K高清画质，快速实现沉浸式3D实景空间漫游。',
  yushou: '【新品预售】',
  price: 'RMB 3,999',
  buy: '立即购买',
  tiaokuan: '* 付款成功后5个工作日内发货，默认顺丰快递包邮',
  guige: {
    name: '技术规格',
    dec: '注：本页面所列配置及参数均以实际上市产品为准，如有变更，恕不另行通知',
    arr: [
      {
        name: '机身尺寸',
        val: ['高度：130mm', '宽度：47mm', '厚度：18mm', '重量：115g']
      },
      {
        name: '材质',
        val: [
          '钛金属',
          '磨砂背'
        ]
      },
      {
        name: '摄像头',
        val: ['f / 2.0 大光圈镜头',
          '3200万像素SONY sensor',
          '220°双鱼眼镜头',
          '9片8组光学镜头',
          '3K视频录制速度为30fps']
      },
      {
        name: '连接',
        val: ['蓝牙：5.0', 'WiFi：802.11a / b / g / n / ac']
      },
      {
        name: '电池',
        val: ['2000mAh', '通过USB快速充电']
      },
      {
        name: '存储',
        val: ['支持128G TF卡', '3K视频 录制120分钟']
      },
      {
        name: '端口',
        val: ['microUSB', '三脚架固定孔']
      }
    ]
  },
  color: {
    key: '颜色',
    val: ' 静谧黑'
  },
  service: {
    type: '容量套餐（5G / 5年）',
    key: '服务',
    val: [
      '首批预购用户，独享5G云容量5年使用权',
      '最高支持6M/s上传',
      '支持分享多个社交平台',
      '支持在3D空间中增加多媒体热点、隐私加密、嵌入网站等功能'
    ]
  },
  gift: {
    key: '赠品',
    val: '四维看看 Lite专用三脚架'
  },
  count: {
    key: '数量'
  }
}



// WEBPACK FOOTER //
// ./src/store/language/cn/purchasetow.js